import React from 'react';
import '../scss/components/_case-study-hero.scss'
import { DemoFormLongPDF} from '../components/DemoFormLongPDF.jsx';
import HtmlParser from 'html-react-parser';

const CaseStudyHero = props => (
    <section className="hero-case-study" style={backgroundStyle(props.background)}>
        <div className="row sectionSpacing contentBlock ">
            <div className="headerContent col-md-6 col-sm-12 text-center">
                {props.titlePosition=="top" ? <h1 className="mb-5">{props.title}</h1>:""}
                <div className="logos-box">
                    <img className="logo-charthop" src='/case-study/charthop-logo.svg' alt="Logo Charthop" />
                    <img className="icon-plus" src='/case-study/plus.svg' alt="Icon Plus" />
                    <img className="logo-company" src={props.logo} alt="Logo Company" />					
                    {props.titlePosition=="bot" ? <h1>{props.title}</h1>:""}
                </div>
            </div>
            <div className="col-md-6 col-sm-12 row justify-content-end mx-auto">
                <div className="col-md-10 col-lg-10 col-xs-12 text-center">
                    <h2>Download {props.name} Case Study</h2>
                    <div className="form-pdf">
                        <DemoFormLongPDF pdfUrl={props.pdfUrl} source={HtmlParser(props.caseStudySource)}/>
                    </div>
                </div>
            </div>
        </div>
    </section>
    );

const backgroundStyle=(url) =>({
    backgroundImage : `url(${url})`,
})
export default CaseStudyHero;
    